
<script setup lang="ts">
import { useHead } from "@vueuse/head"
  const head = {"title":"Legal Notice | Sigma Clinic","meta":[{"property":"og:title","content":"Legal Notice | Sigma Clinic"},{"property":"og:description","content":"Legal notice and company information for Sigma Clinic."},{"name":"description","content":"Legal notice and company information for Sigma Clinic."}]}
  useHead(head)
  const title = "Legal Notice | Sigma Clinic"
 const description = "Legal notice and company information for Sigma Clinic."
 const excerpt = undefined
 const meta = [{"property":"og:title","content":"Legal Notice | Sigma Clinic"},{"property":"og:description","content":"Legal notice and company information for Sigma Clinic."},{"name":"description","content":"Legal notice and company information for Sigma Clinic."}]
  defineExpose({ frontmatter: {"title":"Legal Notice | Sigma Clinic","description":"Legal notice and company information for Sigma Clinic.","meta":[{"property":"og:title","content":"Legal Notice | Sigma Clinic"},{"property":"og:description","content":"Legal notice and company information for Sigma Clinic."},{"name":"description","content":"Legal notice and company information for Sigma Clinic."}]}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {"title":"Legal Notice | Sigma Clinic","description":"Legal notice and company information for Sigma Clinic.","meta":[{"property":"og:title","content":"Legal Notice | Sigma Clinic"},{"property":"og:description","content":"Legal notice and company information for Sigma Clinic."},{"name":"description","content":"Legal notice and company information for Sigma Clinic."}]}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>Legal notice</h1>
<p>Last updated: 16 October 2025</p>
<h3>Operator:</h3>
<p><strong>Sigma Clinic sp. z o.o.</strong></p>
<p>Address: Młynarska 42, 01-171 Warszawa, Poland<br>
KRS: 0001184102 • NIP (VAT): 5273173475
RPWDL medical entity number: 000000294316</p>
<p>Email: contact@sigma.clinic</p>
</div>
</template>
